import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'newLineSanitize'
})
export class NewLineSanitzePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml | null {
    if (!text) {
      return null;
    }

    return this.domSanitizer.bypassSecurityTrustHtml(text.replace(/\\n/g, '<br/>'));
  }
}
